import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/_services';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NextJsSyncGuard implements CanActivate {

  nextjsUrl = environment.nextjsUrl;
  
  constructor(
    private router: Router,
    private auth: AuthService,
    ) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    
    const projectId = +localStorage.getItem('selectedProject');
    
      // First save sync data and only open Next.js window after successful response
      this.saveSyncData().subscribe(
        response => {
          if (response && response.statusCode === 200) {
            this.syncWithNextJs(state.url);
          } else {
            console.error('Syncs data not saved');
          }
        },
        error => {
          console.error('Failed to sync data:', error);
        }
      );
    
    return true;
  }
  

  saveSyncData(): Observable<any> {

    // Get important data from localStorage
    const dataToSaveSync = {
      authToken: localStorage.getItem('authce9d77b308c149d5992a80073637e4d5'),
      userData: localStorage.getItem('currentUser'),
      authce9d77b308c149d5992a80073637e4d5: localStorage.getItem('authce9d77b308c149d5992a80073637e4d5'),
      currentUser: localStorage.getItem('currentUser'),
      menuPermission: localStorage.getItem('menuPermission'),
      pageTitle: localStorage.getItem('pageTitle'),
      pluralName: localStorage.getItem('pluralName'),
      selectedProject: localStorage.getItem('selectedProject'),
      singularName: localStorage.getItem('singularName'),
      systemLogo: localStorage.getItem('systemLogo'),
      systemName: localStorage.getItem('systemName'),
      userMenu: localStorage.getItem('userMenu'),
      userProject: localStorage.getItem('userProject')
    };
    
    // Using URL hash fragment (reliable across origins)
    const encodedData = encodeURIComponent(JSON.stringify(dataToSaveSync));
    // Save localStorage data for synchronization with Next.js
    return this.auth.saveSyncData(encodedData);

  }


  syncWithNextJs(targetRoute: string) {

       const authToken = localStorage.getItem('authce9d77b308c149d5992a80073637e4d5');
       const currentRoute = targetRoute
     
    window.open(this.nextjsUrl+'auth/sync/index.html?token=' + authToken + '&page=' + targetRoute , '_blank');
   }
}